// src/translations/ar.ts

const ar: Record<string, string> = {
  // Common
  'common.loading': 'جاري التحميل...',
  'common.save': 'حفظ',
  'common.cancel': 'إلغاء',
  'common.delete': 'حذف',
  'common.edit': 'تعديل',
  'common.add': 'إضافة',
  'common.confirm': 'تأكيد',
  'common.refresh': 'تحديث',
  'common.search': 'بحث',
  'common.all': 'الكل',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.back': 'رجوع',
  'common.close': 'إغلاق',
  'common.actions': 'الإجراءات',
  'common.status': 'الحالة',
  'common.name': 'الاسم',
  'common.description': 'الوصف',
  'common.price': 'السعر',
  'common.currency': 'د.ع',
  'common.noDescription': 'لا يوجد وصف',
  'common.confirmDelete': 'تأكيد الحذف',
  'common.cannotUndo': 'لا يمكن التراجع عن هذا الإجراء.',
  'common.selected': 'محدد',
  'common.error': 'خطأ',
  'common.success': 'نجاح',
  'common.sorry': 'عذراً!',
  'common.minutes': 'د',
  'common.minute': 'دقيقة',
  'common.table': 'طاولة',
  'common.tableNumber': 'طاولة رقم',
  'common.free': 'مجاني',
  'common.print': 'طباعة',

  // Messages
  'messages.success.login': 'تم تسجيل الدخول بنجاح',
  'messages.success.logout': 'تم تسجيل الخروج بنجاح',
  'messages.success.created': 'تم الإنشاء بنجاح',
  'messages.success.updated': 'تم التحديث بنجاح',
  'messages.success.deleted': 'تم الحذف بنجاح',
  'messages.error.generic': 'حدث خطأ ما. يرجى المحاولة مرة أخرى',
  'messages.error.unauthorized': 'غير مصرح. يرجى تسجيل الدخول',
  'messages.error.network': 'خطأ في الاتصال بالسيرفر',
  'messages.error.validation': 'يرجى التحقق من البيانات المدخلة',

  // Sidebar
  'sidebar.systemAdmin': 'مدير النظام',
  'sidebar.restaurant': 'المطعم',
  'sidebar.dashboard': 'الاحصائيات',
  'sidebar.restaurantProfile': 'ملف المطعم',
  'sidebar.settings': 'الإعدادات',
  'sidebar.orders': 'الطلبات',
  'sidebar.tables': 'الطاولات',
  'sidebar.categories': 'الأقسام',
  'sidebar.dishes': 'الأطباق',
  'sidebar.scheduling': 'الجدولة',
  'sidebar.addDish': 'إضافة طبق',
  'sidebar.logout': 'تسجيل الخروج',
  'sidebar.adminDashboard': 'لوحة التحكم',
  'sidebar.restaurants': 'المطاعم',
  'sidebar.addRestaurant': 'إضافة مطعم',
  'sidebar.language': 'اللغة',
  'sidebar.cashier': 'الكاشير',
  'sidebar.inventory': 'المخزون',
  'sidebar.templates': 'قوالب التحضير',
  'sidebar.profile': 'الملف الشخصي',

  // Navbar
  'nav.dashboard': 'لوحة التحكم',
  'nav.login': 'تسجيل الدخول',
  'nav.loginShort': 'دخول',
  'nav.logout': 'تسجيل الخروج',
  'nav.systemAdmin': 'مدير النظام',
  'nav.restaurantOwner': 'صاحب المطعم',
  'nav.services': 'خدماتنا',
  'nav.about': 'حولنا',
  'nav.partners': 'شركاؤنا',

  // Auth / Login
  'auth.welcomeBack': 'مرحباً بك مجدداً',
  'auth.loginSubtitle': 'قم بتسجيل الدخول للوصول إلى لوحة التحكم',
  'auth.emailOrUsername': 'اسم المستخدم أو البريد الإلكتروني',
  'auth.password': 'كلمة المرور',
  'auth.loginButton': 'تسجيل الدخول',
  'auth.loginFailed': 'فشل تسجيل الدخول. يرجى التحقق من البيانات المدخلة',
  'auth.backToHome': 'العودة للرئيسية',
  'auth.demoAccounts': 'حسابات تجريبية:',
  'auth.adminAccount': 'حساب المسؤول',
  'auth.restaurantAccount': 'حساب المطعم',
  'auth.menuSystem': 'نظام إدارة المنيو',

  // Dashboard
  'dashboard.title': 'الاحصائيات',
  'dashboard.adminTitle': 'لوحة تحكم المسؤول',
  'dashboard.welcome': 'مرحباً بك،',
  'dashboard.welcomeMessage': 'مرحباً بك في لوحة التحكم',
  'dashboard.loading': 'جاري تحميل لوحة التحكم...',
  'dashboard.loadingStats': 'جاري تحميل الإحصائيات...',
  'dashboard.revenue': 'الإيرادات',
  'dashboard.totalOrders': 'إجمالي الطلبات',
  'dashboard.totalRestaurants': 'إجمالي المطاعم',
  'dashboard.totalDishes': 'إجمالي الأطباق',
  'dashboard.activeRestaurants': 'المطاعم النشطة',
  'dashboard.restaurantOwners': 'أصحاب المطاعم',
  'dashboard.completedOrders': 'الطلبات المكتملة',
  'dashboard.cancelledOrders': 'الطلبات الملغاة',
  'dashboard.copyLink': 'نسخ الرابط',
  'dashboard.copied': 'تم النسخ!',
  'dashboard.viewMenu': 'عرض المنيو',
  'dashboard.filterData': 'تصفية البيانات',
  'dashboard.choosePeriod': 'اختر الفترة الزمنية',
  'dashboard.today': 'اليوم',
  'dashboard.thisWeek': 'هذا الأسبوع',
  'dashboard.thisMonth': 'هذا الشهر',
  'dashboard.thisYear': 'هذه السنة',
  'dashboard.customPeriod': 'فترة مخصصة',
  'dashboard.fromDate': 'من تاريخ',
  'dashboard.toDate': 'إلى تاريخ',
  'dashboard.applyFilter': 'تطبيق الفلتر',
  'dashboard.linkCopied': 'تم نسخ رابط المنيو بنجاح!',

  // Profile
  'profile.loading': 'جاري تحميل الملف الشخصي...',
  'profile.loadFailed': 'فشل تحميل بيانات المطعم',
  'profile.editProfile': 'تعديل الملف الشخصي',
  'profile.allDishes': 'جميع الأطباق',
  'profile.otherDishes': 'أطباق أخرى',
  'profile.unavailable': 'غير متوفر',
  'profile.noDishesInCategory': 'لا توجد أطباق في هذا القسم',
  'profile.addDishesHint': 'قم بإضافة أطباق جديدة من لوحة التحكم',
  'profile.loadingData': 'جاري تحميل بيانات المطعم...',
  'profile.backToProfile': 'العودة للملف الشخصي',
  'profile.editTitle': 'تعديل الملف الشخصي',
  'profile.updateInfo': 'قم بتحديث معلومات مطعمك وصوره',

  // Categories
  'categories.title': 'إدارة الأقسام',
  'categories.subtitle': 'قم بإضافة وتنظيم أقسام المنيو الخاص بك • اسحب لإعادة الترتيب',
  'categories.addCategory': 'إضافة قسم',
  'categories.addNewCategory': 'إضافة قسم جديد',
  'categories.editCategory': 'تعديل القسم',
  'categories.categoryName': 'اسم القسم',
  'categories.displayOrder': 'ترتيب العرض',
  'categories.displayOrderHint': 'يستخدم لترتيب الأقسام في المنيو',
  'categories.saveChanges': 'حفظ التعديلات',
  'categories.totalCategories': 'إجمالي الأقسام',
  'categories.totalDishes': 'إجمالي الأطباق',
  'categories.noCategories': 'لا توجد أقسام بعد',
  'categories.startAdding': 'ابدأ بإضافة أول قسم لمنيو مطعمك',
  'categories.loadingCategories': 'جاري تحميل الأقسام...',
  'categories.loadFailed': 'فشل تحميل الأقسام',
  'categories.createSuccess': 'تم إضافة القسم بنجاح',
  'categories.updateSuccess': 'تم تحديث القسم بنجاح',
  'categories.deleteSuccess': 'تم حذف القسم بنجاح',
  'categories.saveFailed': 'فشل حفظ القسم',
  'categories.deleteFailed': 'فشل حذف القسم',
  'categories.reorderSuccess': 'تم تحديث ترتيب الأقسام بنجاح',
  'categories.reorderFailed': 'فشل تحديث الترتيب',
  'categories.deleteConfirm': 'هل أنت متأكد من حذف القسم',
  'categories.deleteWarning': 'سيتم نقل جميع الأطباق في هذا القسم إلى "بدون قسم".',
  'categories.deleteCategory': 'حذف القسم',
  'categories.dish': 'طبق',
  'categories.order': 'الترتيب',
  'categories.dishCount': 'عدد الأطباق',
  'categories.createdAt': 'تاريخ الإنشاء',

  // Dishes
  'dishes.title': 'إدارة الأطباق',
  'dishes.subtitle': 'عرض وإدارة جميع الأطباق',
  'dishes.dishCount': 'طبق',
  'dishes.addDish': 'إضافة طبق',
  'dishes.addNewDish': 'إضافة طبق جديد',
  'dishes.totalDishes': 'إجمالي الأطباق',
  'dishes.available': 'متاح',
  'dishes.unavailable': 'غير متاح',
  'dishes.categoriesCount': 'الأقسام',
  'dishes.searchPlaceholder': 'البحث عن طبق...',
  'dishes.category': 'القسم',
  'dishes.noCategoryFilter': 'بدون قسم',
  'dishes.dishList': 'قائمة الأطباق',
  'dishes.availableDishes': 'طبق متاح',
  'dishes.dish': 'الطبق',
  'dishes.section': 'القسم',
  'dishes.statusLabel': 'الحالة',
  'dishes.loadingDishes': 'جاري تحميل الأطباق...',
  'dishes.noDishes': 'لا توجد أطباق',
  'dishes.startAdding': 'ابدأ بإضافة أطباق لمنيو مطعمك',
  'dishes.deleteConfirm': 'هل أنت متأكد من حذف الطبق',
  'dishes.deleteDish': 'حذف الطبق',
  'dishes.setAvailable': 'تعيين كمتاح',
  'dishes.setUnavailable': 'تعيين كغير متاح',
  'dishes.clearSelection': 'إلغاء التحديد',
  'dishes.updateStatus': 'تحديث الحالة',
  'dishes.bulkStatusConfirm': 'هل تريد تحديث حالة',
  'dishes.bulkStatusTo': 'طبق إلى',
  'dishes.pausedUntil': 'متوقف حتى',
  'dishes.preview': 'معاينة',
  'dishes.quickPause': 'إيقاف سريع',
  'dishes.pause': 'إيقاف',
  'dishes.pauseDishDesc': 'إيقاف الطبق مؤقتاً',
  'dishes.pauseReasonOptional': 'سبب الإيقاف (اختياري)',
  'dishes.pauseReasonPlaceholder': 'مثال: نفذت المكونات...',
  'dishes.dishPausedTemp': 'تم إيقاف الطبق مؤقتاً',
  'dishes.reactivateDishNow': 'إعادة تفعيل الآن',
  'dishes.willReturnAt': 'سيعود في',
  'dishes.remaining': 'متبقي',
  'dishes.ended': 'انتهى',
  'dishes.hoursCount': 'ساعة',
  'dishes.or': 'أو',
  'dishes.addOnGroup': 'مجموعة الإضافات',
  'dishes.addOnGroupName': 'اسم المجموعة',
  'dishes.addOnItem': 'عنصر الإضافة',
  'dishes.required': 'مطلوب',
  'dishes.optional': 'اختياري',
  'dishes.minSelection': 'الحد الأدنى للاختيار',
  'dishes.maxSelection': 'الحد الأقصى للاختيار',
  'dishes.addAddOnGroup': 'إضافة مجموعة إضافات',
  'dishes.addAddOnItem': 'إضافة عنصر',
  'dishes.addOnPrice': 'سعر الإضافة',
  'dishes.details': 'تفاصيل الطبق',

  // Dish Form
  'dishForm.createTitle': 'إضافة طبق جديد',
  'dishForm.editTitle': 'تعديل الطبق',
  'dishForm.backToDishes': 'العودة للأطباق',
  'dishForm.dishName': 'اسم الطبق',
  'dishForm.dishDescription': 'وصف الطبق',
  'dishForm.dishPrice': 'السعر',
  'dishForm.dishCategory': 'القسم',
  'dishForm.noCategory': 'بدون قسم',
  'dishForm.dishStatus': 'حالة الطبق',
  'dishForm.dishImage': 'صورة الطبق',
  'dishForm.uploadImage': 'رفع صورة',
  'dishForm.removeImage': 'إزالة الصورة',
  'dishForm.saveDish': 'حفظ الطبق',
  'dishForm.createDish': 'إضافة الطبق',
  'dishForm.updateDish': 'تحديث الطبق',
  'dishForm.loadingData': 'جاري تحميل البيانات...',
  'dishForm.loadFailed': 'فشل تحميل بيانات الطبق',
  'dishForm.createSuccess': 'تم إضافة الطبق بنجاح',
  'dishForm.updateSuccess': 'تم تحديث الطبق بنجاح',
  'dishForm.saveFailed': 'فشل حفظ الطبق',

  // Orders
  'orders.title': 'إدارة الطلبات',
  'orders.subtitle': 'عرض وإدارة جميع الطلبات',
  'orders.orderCount': 'طلب',
  'orders.totalOrders': 'إجمالي الطلبات',
  'orders.completed': 'مكتملة',
  'orders.totalRevenue': 'إجمالي الإيرادات',
  'orders.noOrders': 'لا توجد طلبات',
  'orders.newOrdersHint': 'ستظهر الطلبات الجديدة هنا',
  'orders.connected': 'متصل',
  'orders.disconnected': 'غير متصل',
  'orders.notifications': 'الإشعارات',
  'orders.allTab': 'الكل',
  'orders.newTab': 'الجديدة',
  'orders.confirmedTab': 'المؤكدة',
  'orders.preparingTab': 'قيد التحضير',
  'orders.completedTab': 'مكتملة',
  'orders.cancelledTab': 'ملغية',
  'orders.returnedTab': 'الراجع',
  'orders.searchPlaceholder': 'البحث برقم الطلب، اسم العميل، أو رقم الهاتف...',
  'orders.orderType': 'نوع الطلب',
  'orders.delivery': 'توصيل',
  'orders.pickup': 'استلام',
  'orders.dineIn': 'داخل المطعم',
  'orders.loadingOrders': 'جاري تحميل الطلبات...',
  'orders.customerName': 'اسم العميل',
  'orders.customerInfo': 'معلومات العميل',
  'orders.date': 'التاريخ',
  'orders.itemCount': 'عدد المنتجات',
  'orders.product': 'منتج',
  'orders.orderDetails': 'تفاصيل الطلب',
  'orders.orderNotes': 'ملاحظات الطلب',
  'orders.cancelOrder': 'إلغاء الطلب',
  'orders.total': 'الإجمالي',
  'orders.loadFailed': 'فشل تحميل الطلبات',
  'orders.newOrder': 'طلب جديد!',
  'orders.orderCancelled': 'تم إلغاء الطلب',
  'orders.statusUpdateSuccess': 'تم تحديث حالة الطلب بنجاح',
  'orders.statusUpdateFailed': 'فشل تحديث حالة الطلب',
  'orders.updateSuccessPrintFailed': 'تم تحديث الطلب ولكن فشلت الطباعة',
  'orders.cancelSuccess': 'تم إلغاء الطلب بنجاح',
  'orders.cancelFailed': 'فشل إلغاء الطلب',
  'orders.dineInCustomer': 'زبون داخل المطعم',
  'orders.status': 'الحالة',
  'orders.customer': 'العميل',
  'orders.items': 'المنتجات',
  'orders.time': 'الوقت',
  'orders.actions': 'الإجراءات',
  'orders.orderNumber': 'رقم الطلب',

  // Order Status
  'orderStatus.pending': 'قيد الانتظار',
  'orderStatus.confirmed': 'تم التأكيد',
  'orderStatus.preparing': 'قيد التحضير',
  'orderStatus.completed': 'مكتمل',
  'orderStatus.returned': 'راجع',
  'orderStatus.cancelled': 'ملغي',

  // Table Status
  'tableStatus.available': 'متاح',
  'tableStatus.occupied': 'مشغول',
  'tableStatus.reserved': 'محجوز',

  // Order Type
  'orderType.delivery': 'توصيل',
  'orderType.pickup': 'استلام',
  'orderType.dine_in': 'داخل المطعم',
  'orderType.takeaway': 'سفري',
  'orderType.cashier': 'كاشير',
  'orderType.delivery_company': 'شركة توصيل',
  'cashier.deliveryCompany': 'شركة التوصيل',
  'cashier.selectCompany': 'اختر شركة التوصيل',
  'cashier.externalOrderNumber': 'الرقم الخارجي للطلب',
  'cashier.enterExternalNumber': 'أدخل الرقم الخارجي للطلب...',
  'cashier.deliveryCompanyCheckout': 'تفاصيل طلب شركة التوصيل',

  // Tables
  'tables.title': 'إدارة الطاولات',
  'tables.subtitle': 'عرض وإدارة طاولات المطعم',
  'tables.manageDescription': 'إدارة طاولات المطعم وأكواد QR',
  'tables.addTable': 'إضافة طاولة',
  'tables.addTablesHint': 'ابدأ بإضافة طاولات لمطعمك',
  'tables.loadFailed': 'فشل تحميل الطاولات',
  'tables.loading': 'جاري تحميل الطاولات...',
  'tables.noTables': 'لا توجد طاولات',
  'tables.tableCount': 'طاولة',
  'tables.totalTables': 'إجمالي الطاولات',
  'tables.active': 'نشطة',
  'tables.inactive': 'غير نشطة',
  'tables.activeStatus': 'الحالة النشطة',
  'tables.statusLabel': 'الحالة',
  'tables.saveSuccess': 'تم حفظ الطاولة بنجاح',
  'tables.seats': 'مقاعد',
  'tables.activeOrders': 'طلب نشط',
  'tables.disabled': 'معطلة',
  'tables.available': 'متاحة',
  'tables.occupied': 'مشغولة',
  'tables.reserved': 'محجوزة',
  'tables.activeOrder': 'طلب نشط',
  'tables.statusAvailable': 'متاح',
  'tables.statusOccupied': 'مشغول',
  'tables.statusReserved': 'محجوز',
  'tables.disable': 'تعطيل',
  'tables.enable': 'تفعيل',
  'tables.viewQRCode': 'عرض QR Code',
  'tables.editTable': 'تعديل الطاولة',
  'tables.addNewTable': 'إضافة طاولة جديدة',
  'tables.tableNumberRequired': 'رقم الطاولة مطلوب',
  'tables.tableNumberLabel': 'رقم الطاولة',
  'tables.tableNumberPlaceholder': 'مثال: 1، A1، VIP-5',
  'tables.locationOptional': 'الموقع (اختياري)',
  'tables.locationPlaceholder': 'مثال: الطابق الأول، الصالة الخارجية',
  'tables.seatsOptional': 'عدد المقاعد (اختياري)',
  'tables.seatsPlaceholder': 'مثال: 4',
  'tables.saveError': 'حدث خطأ أثناء الحفظ',
  'tables.saveChanges': 'حفظ التعديلات',

  // Scheduling
  'scheduling.title': 'جدولة الأطباق',
  'scheduling.subtitle': 'إدارة توفر الأطباق وجدولتها من مكان واحد',
  'scheduling.dishCount': 'طبق',
  'scheduling.menuOpen': 'المنيو مفتوح',
  'scheduling.menuClosed': 'المنيو مغلق',
  'scheduling.menuOpenDesc': 'العملاء يمكنهم عرض القائمة والطلب',
  'scheduling.menuClosedDesc': 'العملاء يمكنهم عرض القائمة فقط بدون طلب',
  'scheduling.searchDish': 'البحث عن طبق...',
  'scheduling.scheduleDishes': 'جدولة الأطباق',
  'scheduling.allFilter': 'تحديث',
  'scheduling.availableNow': 'متوفر الآن',
  'scheduling.pausedFilter': 'إيقاف مؤقت',
  'scheduling.unavailableFilter': 'غير متوفر',
  'scheduling.hasSchedule': 'لديه جدول',
  'scheduling.noMatchingDishes': 'لا توجد أطباق مطابقة للبحث',
  'scheduling.noDishes': 'لا توجد أطباق',
  'scheduling.dishCol': 'الطبق',
  'scheduling.statusCol': 'الحالة',
  'scheduling.scheduleCol': 'الجدول',
  'scheduling.availabilityCol': 'التوفر',
  'scheduling.actionsCol': 'الإجراءات',
  'scheduling.scheduled': 'مجدول',
  'scheduling.pauseTemp': 'إيقاف مؤقت',
  'scheduling.schedule': 'جدولة',
  'scheduling.reactivate': 'إعادة تفعيل',
  'scheduling.pauseFor': 'إيقاف مؤقت لمدة:',
  'scheduling.scheduleAvailability': 'جدول التوفر',
  'scheduling.saveSchedule': 'حفظ الجدول',
  'scheduling.loadingDishes': 'جاري تحميل الأطباق...',
  'scheduling.loadFailed': 'فشل تحميل الأطباق',
  'scheduling.menuOpenSuccess': 'تم فتح استقبال الطلبات',
  'scheduling.menuCloseSuccess': 'تم إغلاق استقبال الطلبات',
  'scheduling.menuToggleFailed': 'فشل تحديث حالة القائمة',
  'scheduling.dishActivated': 'تم تفعيل الطبق',
  'scheduling.dishDeactivated': 'تم إيقاف الطبق',
  'scheduling.dishToggleFailed': 'فشل تحديث حالة الطبق',
  'scheduling.dishPausedFor': 'تم إيقاف',
  'scheduling.dishPausedForSuffix': 'لمدة',
  'scheduling.hourSuffix': 'ساعة',
  'scheduling.dishPauseFailed': 'فشل إيقاف الطبق مؤقتاً',
  'scheduling.dishReactivated': 'تم إعادة تفعيل',
  'scheduling.dishReactivateFailed': 'فشل إعادة تفعيل الطبق',
  'scheduling.scheduleSaved': 'تم حفظ جدول التوفر',
  'scheduling.scheduleSaveFailed': 'فشل حفظ جدول التوفر',
  'scheduling.pausedUntil': 'إيقاف مؤقت',
  'scheduling.notAvailable': 'غير متوفر',
  'scheduling.availableStatus': 'متوفر',
  'scheduling.hour1': '1 ساعة',
  'scheduling.hour2': '2 ساعة',
  'scheduling.hour4': '4 ساعات',
  'scheduling.hour8': '8 ساعات',
  'scheduling.fullDay': 'يوم كامل',
  'scheduling.hours': 'س',
  'scheduling.minutes': 'د',
  'scheduling.minute': 'دقيقة',

  // Admin
  'admin.dashboard': 'لوحة تحكم المسؤول',
  'admin.restaurants': 'المطاعم',
  'admin.restaurantCount': 'مطعم مسجل في النظام',
  'admin.addRestaurant': 'إضافة مطعم جديد',
  'admin.searchRestaurant': 'ابحث عن مطعم بالاسم أو صاحب المطعم...',
  'admin.loading': 'جاري التحميل...',
  'admin.noRestaurants': 'لا توجد مطاعم',
  'admin.startAdding': 'ابدأ بإضافة مطعم جديد للنظام',
  'admin.restaurantOwner': 'صاحب المطعم',
  'admin.active': 'نشط',
  'admin.inactive': 'غير نشط',
  'admin.loadFailed': 'فشل تحميل المطاعم',
  'admin.deleteFailed': 'فشل حذف المطعم',
  'admin.totalRestaurants': 'إجمالي المطاعم',
  'admin.totalCategories': 'إجمالي الأقسام',
  'admin.totalDishes': 'إجمالي الأطباق',
  'admin.totalTables': 'الطاولات',

  // Admin Restaurant Form
  'adminForm.createTitle': 'إضافة مطعم جديد',
  'adminForm.createSubtitle': 'أضف مطعم جديد للنظام',
  'adminForm.editTitle': 'تعديل المطعم',
  'adminForm.editSubtitle': 'تعديل بيانات المطعم',
  'adminForm.backToRestaurants': 'العودة للمطاعم',
  'adminForm.whatsappNotifications': 'إشعارات واتساب',
  'adminForm.whatsappNotificationsDesc': 'استلام إشعارات الطلبات الجديدة عبر واتساب',
  'adminForm.whatsappNumber': 'رقم واتساب',
  'adminForm.whatsappNumberHint': 'رقم الهاتف لاستلام الإشعارات',
  'adminForm.tableOrderingEnabled': 'الطلب من الطاولة مفعّل',
  'adminForm.tableOrderingDisabled': 'الطلب من الطاولة معطّل',
  'adminForm.tableOrderingHint': 'تحكم بإمكانية الطلب عند مسح QR الطاولة (عرض القائمة فقط أو مع الطلب)',
  'adminForm.whatsappEnabled': 'إشعارات واتساب',
  'adminForm.whatsappDisabled': 'إشعارات واتساب',
  'adminForm.subscriptionDays': 'مدة التفعيل (أيام)',
  'adminForm.subscriptionDaysHint': 'عدد الأيام قبل تعطيل الحساب تلقائياً. اتركه فارغاً بدون توقف.',

  // Home Page
  'home.heroTitle': 'منيو رقمي ذكي لمطعمك',
  'home.heroSubtitle': 'أنشئ منيو رقمي احترافي بكود QR وابدأ استقبال الطلبات اونلاين',
  'home.startNow': 'ابدأ الآن',
  'home.watchDemo': 'شاهد العرض',
  'home.servicesTitle': 'خدماتنا',
  'home.aboutTitle': 'من نحن',
  'home.partnersTitle': 'شركاؤنا',
  'home.feature1Title': 'قوائم طعام رقمية',
  'home.feature1Desc': 'قوائم تفاعلية سهلة التصفح مع صور عالية الجودة لأطباقك',
  'home.feature2Title': 'إدارة ذكية',
  'home.feature2Desc': 'لوحة تحكم شاملة لإدارة المطعم والطلبات بسهولة',
  'home.feature3Title': 'زيادة المبيعات',
  'home.feature3Desc': 'أدوات تسويقية وتحليلات لزيادة إيراداتك',

  // Menu Page (Public)
  'menu.loading': 'جاري تحميل المنيو...',
  'menu.notFound': 'المنيو غير موجود',
  'menu.searchDish': 'ابحث عن طبق...',
  'menu.allCategories': 'الكل',
  'menu.addToCart': 'أضف للسلة',
  'menu.add': 'اضافة',
  'menu.outOfStock': 'غير متوفر',
  'menu.menuClosed': 'المنيو مغلق حالياً',
  'menu.restaurantNotAccepting': 'المنيو مغلق حالياً',
  'menu.menuClosedMessage': 'عذراً، المطعم لا يستقبل الطلبات في الوقت الحالي. يرجى المحاولة لاحقاً.',
  'menu.notAcceptingOrders': 'المطعم لا يستقبل الطلبات حالياً',
  'menu.tableOrderingDisabled': 'الطلب من الطاولة غير مفعّل لهذا المطعم، يمكنك تصفح القائمة فقط',
  'menu.dishUnavailable': 'هذا الطبق غير متوفر حالياً',
  'menu.browseMenu': 'تصفح المنيو فقط',
  'menu.dishAdded': 'تمت الإضافة للسلة',
  'menu.addError': 'فشل إضافة الطبق للسلة',
  'menu.updateError': 'فشل تحديث الكمية',
  'menu.dishRemoved': 'تم إزالة الطبق من السلة',
  'menu.sorry': 'عذراً!',
  'menu.tableNumber': 'طاولة رقم',

  // Cart
  'cart.title': 'سلة التسوق',
  'cart.empty': 'السلة فارغة',
  'cart.emptyHint': 'أضف بعض الأطباق اللذيذة إلى سلتك',
  'cart.total': 'الإجمالي',
  'cart.checkout': 'إتمام الطلب',
  'cart.continueShopping': 'متابعة التسوق',
  'cart.removeItem': 'إزالة',
  'cart.clearCart': 'تفريغ السلة',
  'cart.addFailed': 'فشل إضافة العنصر للسلة',
  'cart.updateFailed': 'فشل تحديث العنصر',
  'cart.removeFailed': 'فشل حذف العنصر',
  'cart.clearFailed': 'فشل تفريغ السلة',
  'cart.loading': 'جاري تحميل السلة...',
  'cart.canKeepCart': 'يمكنك الاحتفاظ بالسلة والطلب لاحقاً',

  // Checkout
  'checkout.title': 'إتمام الطلب',
  'checkout.customerName': 'الاسم',
  'checkout.phone': 'رقم الهاتف',
  'checkout.address': 'العنوان',
  'checkout.notes': 'ملاحظات',
  'checkout.orderType': 'نوع الطلب',
  'checkout.placeOrder': 'تأكيد الطلب',
  'checkout.orderSummary': 'ملخص الطلب',
  'checkout.subtotal': 'المجموع الفرعي',
  'checkout.deliveryFee': 'رسوم التوصيل',
  'checkout.grandTotal': 'الإجمالي',
  'checkout.quantity': 'الكمية',
  'checkout.creatingOrder': 'جاري إنشاء الطلب...',
  'checkout.orderConfirmationNote': 'سيتم إرسال تفاصيل الطلب عبر الهاتف',
  'checkout.loading': 'جاري تحميل بيانات الطلب...',
  'checkout.dineIn': 'طلب داخلي',
  'checkout.tableNumber': 'طاولة رقم',

  // Order Success
  'orderSuccess.title': 'تم إرسال طلبك بنجاح!',
  'orderSuccess.thankYou': 'شكراً لطلبك!',
  'orderSuccess.orderNumber': 'رقم الطلب',
  'orderSuccess.trackOrder': 'تتبع الطلب',
  'orderSuccess.backToMenu': 'العودة للمنيو',
  'orderSuccess.backToHome': 'العودة للرئيسية',
  'orderSuccess.noData': 'لا توجد بيانات للطلب',

  // Track Order
  'trackOrder.title': 'تتبع الطلب',
  'trackOrder.subtitle': 'أدخل رقم هاتفك لتتبع طلبك',
  'trackOrder.orderStatus': 'حالة الطلب',
  'trackOrder.orderDetails': 'تفاصيل الطلب',
  'trackOrder.enterRequired': 'يرجى إدخال رقم الهاتف',
  'trackOrder.notFound': 'لم يتم العثور على طلبات',

  // Notifications
  'notifications.settings': 'إعدادات الإشعارات',
  'notifications.enableSound': 'تفعيل الصوت',
  'notifications.volume': 'مستوى الصوت',
  'notifications.testSound': 'اختبار الصوت',
  'notifications.playing': 'جاري التشغيل...',
  'notifications.repeatCount': 'عدد التكرار',
  'notifications.once': 'مرة واحدة',
  'notifications.fiveTimes': '5 مرات',
  'notifications.reset': 'إعادة تعيين',
  'notifications.alertInfo': 'ستسمع صوت تنبيه عند وصول طلب جديد',

  // WhatsApp
  'whatsapp.support': 'تواصل معنا عبر واتساب',

  // Protected Route
  'protected.unauthorized': 'غير مصرح بالوصول',
  'protected.loginRequired': 'يرجى تسجيل الدخول للوصول إلى هذه الصفحة',

  // Loading
  'loading.text': 'جاري التحميل...',

  // Profile Components
  'profileComp.logo': 'شعار المطعم',
  'profileComp.background': 'صورة الغلاف',
  'profileComp.basicInfo': 'المعلومات الأساسية',
  'profileComp.contactInfo': 'معلومات التواصل',
  'profileComp.socialLinks': 'روابط التواصل الاجتماعي',
  'profileComp.menuSettings': 'إعدادات المنيو',
  'profileComp.restaurantName': 'اسم المطعم',
  'profileComp.restaurantDesc': 'وصف المطعم',
  'profileComp.phone': 'رقم الهاتف',
  'profileComp.primaryPhone': 'الرقم الرئيسي',
  'profileComp.additionalPhone': 'رقم إضافي',
  'profileComp.addPhone': 'إضافة رقم هاتف',
  'profileComp.removePhone': 'حذف الرقم',
  'profileComp.workingHours': 'ساعات العمل',
  'profileComp.address': 'العنوان',
  'profileComp.mapUrl': 'رابط الخريطة',
  'profileComp.timezone': 'المنطقة الزمنية',
  'profileComp.facebook': 'فيسبوك',
  'profileComp.instagram': 'انستغرام',
  'profileComp.twitter': 'تويتر',
  'profileComp.uploadLogo': 'رفع الشعار',
  'profileComp.removeLogo': 'إزالة الشعار',
  'profileComp.uploadBackground': 'رفع صورة الغلاف',
  'profileComp.removeBackground': 'إزالة صورة الغلاف',
  'profileComp.dragOrClick': 'اسحب الصورة هنا أو انقر للاختيار',
  'profileComp.saveChanges': 'حفظ التغييرات',
  'profileComp.saving': 'جاري الحفظ...',
  'profileComp.isMenuPublic': 'هل المنيو عام؟',

  // Restaurant components
  'restaurant.recentOrders': 'الطلبات الأخيرة',
  'restaurant.topDishes': 'الأطباق الأكثر طلباً',
  'restaurant.revenueChart': 'مخطط الإيرادات',
  'restaurant.ordersSummary': 'ملخص الطلبات',
  'restaurant.preparingOrders': 'طلبات قيد التحضير',
  'restaurant.completedOrders': 'طلبات مكتملة',
  'restaurant.noRecentOrders': 'لا توجد طلبات حديثة',
  'restaurant.viewAllOrders': 'عرض كل الطلبات',
  'restaurant.quickActions': 'إجراءات سريعة',
  'restaurant.restaurantInfo': 'معلومات المطعم',
  'restaurant.welcomeMessage': 'مرحباً بك في لوحة التحكم',
  'restaurant.todayStats': 'إحصائيات اليوم',
  'restaurant.viewDetails': 'عرض التفاصيل',
  'restaurant.manageOrders': 'إدارة الطلبات',
  'restaurant.manageTables': 'إدارة الطاولات',
  'restaurant.manageMenu': 'إدارة المنيو',

  // Admin form
  'adminForm.restaurantName': 'اسم المطعم',
  'adminForm.ownerName': 'اسم المالك',
  'adminForm.ownerEmail': 'البريد الإلكتروني للمالك',
  'adminForm.ownerPassword': 'كلمة مرور المالك',
  'adminForm.restaurantSlug': 'الرابط المختصر',
  'adminForm.isActive': 'نشط',
  'adminForm.createRestaurant': 'إنشاء المطعم',
  'adminForm.updateRestaurant': 'تحديث المطعم',
  'adminForm.requiredField': 'هذا الحقل مطلوب',
  'adminForm.saving': 'جاري الحفظ...',
  'adminForm.cancel': 'إلغاء',

  // Additional keys
  'cart.itemsInCart': 'عنصر في السلة',
  'cart.browseRestaurants': 'العودة للمنيو',
  'cart.noItemsYet': 'لم تقم بإضافة أي أطباق بعد',
  'cart.dish': 'طبق',
  'cart.free': 'مجاني',
  'cart.addOns': 'الإضافات',
  'cart.freePerDish': 'مجاني لكل طبق',
  'cart.maxLimit': 'الحد الأقصى',
  'cart.orderSummary': 'ملخص الطلب',
  'cart.reviewOrder': 'مراجعة طلبك',
  'cart.subtotal': 'المجموع الفرعي',
  'cart.serviceFee': 'رسوم الخدمة',
  'cart.deliveryFees': 'رسوم التوصيل',
  'cart.determinedLater': 'يُحدد لاحقاً',
  'cart.restaurantNotAccepting': 'المطعم لا يستقبل الطلبات حالياً',
  'cart.tryLater': 'يرجى المحاولة لاحقاً',
  'cart.termsAgree': 'بالضغط على "إتمام الطلب" أنت توافق على شروط الخدمة',

  // Hook Messages
  'hooks.fillRequiredFields': 'يرجى ملء جميع الحقول المطلوبة',
  'hooks.enterDeliveryAddress': 'يرجى إدخال عنوان التوصيل',
  'hooks.createOrderFailed': 'فشل إنشاء الطلب',
  'hooks.loadStatsFailed': 'فشل تحميل الإحصائيات',
  'hooks.loginFailed': 'فشل تسجيل الدخول. يرجى التحقق من البيانات المدخلة',
  'hooks.loadTablesFailed': 'فشل تحميل الطاولات',
  'hooks.tableDeleteSuccess': 'تم حذف الطاولة بنجاح',
  'hooks.tableDeleteFailed': 'فشل حذف الطاولة',
  'hooks.tableStatusUpdateSuccess': 'تم تحديث حالة الطاولة بنجاح',
  'hooks.tableStatusUpdateFailed': 'فشل تحديث حالة الطاولة',
  'hooks.tableEnabled': 'تم تفعيل الطاولة بنجاح',
  'hooks.tableDisabled': 'تم تعطيل الطاولة بنجاح',
  'hooks.loadDishFailed': 'فشل تحميل بيانات الطبق',
  'hooks.fileSizeError': 'حجم الملف يجب أن يكون أقل من 5MB',
  'hooks.fileTypeError': 'نوع الملف غير مدعوم. يرجى استخدام JPG, PNG, أو WEBP',
  'hooks.dishUpdateSuccess': 'تم تحديث الطبق بنجاح',
  'hooks.dishCreateSuccess': 'تم إضافة الطبق بنجاح',
  'hooks.dishSaveFailed': 'فشل حفظ الطبق',
  'hooks.dishPauseSuccess': 'تم إيقاف الطبق مؤقتاً',
  'hooks.dishPauseFailed': 'فشل إيقاف الطبق',
  'hooks.dishReactivateSuccess': 'تم إعادة تفعيل الطبق',
  'hooks.dishReactivateFailed': 'فشل إعادة تفعيل الطبق',
  'hooks.loadRestaurantFailed': 'فشل تحميل بيانات المطعم',
  'hooks.profileUpdateSuccess': 'تم تحديث الملف بنجاح',
  'hooks.profileUpdateFailed': 'فشل تحديث الملف',
  'hooks.loadDishesFailed': 'فشل تحميل الأطباق',
  'hooks.dishDeleteSuccess': 'تم حذف الطبق بنجاح',
  'hooks.dishDeleteFailed': 'فشل حذف الطبق',
  'hooks.statusUpdateFailed': 'فشل تحديث الحالة',
  'hooks.noCategory': 'بدون قسم',
  'hooks.dishOrderUpdateSuccess': 'تم تحديث ترتيب الأطباق بنجاح',
  'hooks.dishOrderUpdateFailed': 'فشل تحديث الترتيب',
  'hooks.sseConnectionFailed': 'فشل الاتصال بخادم الإشعارات',
  'hooks.loadRestaurantsFailed': 'فشل تحميل المطاعم',
  'hooks.restaurantDeleteFailed': 'فشل حذف المطعم',
  'hooks.loadDashboardFailed': 'فشل تحميل بيانات لوحة التحكم',
  'hooks.restaurantLoadFailed': 'فشل تحميل بيانات المطعم',
  'hooks.restaurantUpdateSuccess': 'تم تحديث المطعم بنجاح',
  'hooks.restaurantCreateSuccess': 'تم إنشاء المطعم بنجاح',
  'hooks.restaurantSaveFailed': 'فشل حفظ المطعم',
  'hooks.loadCategoriesFailed': 'فشل تحميل الأقسام',
  'hooks.categoryCreateSuccess': 'تم إضافة القسم بنجاح',
  'hooks.categoryCreateFailed': 'فشل إضافة القسم',
  'hooks.categoryUpdateSuccess': 'تم تحديث القسم بنجاح',
  'hooks.categoryUpdateFailed': 'فشل تحديث القسم',
  'hooks.categoryDeleteSuccess': 'تم حذف القسم بنجاح',
  'hooks.categoryDeleteFailed': 'فشل حذف القسم',
  'hooks.categoryOrderUpdateSuccess': 'تم تحديث ترتيب الأقسام بنجاح',

  // Inventory (Materials)
  'inventory.title': 'إدارة المخزون',
  'inventory.subtitle': 'إدارة المواد الخام والمكونات',
  'inventory.addMaterial': 'إضافة مادة',
  'inventory.editMaterial': 'تعديل المادة',
  'inventory.materialName': 'اسم المادة',
  'inventory.quantity': 'الكمية',
  'inventory.price': 'السعر الإجمالي',
  'inventory.unitType': 'وحدة القياس',
  'inventory.lowStockThreshold': 'حد التنبيه',
  'inventory.lowStockThresholdHint': 'ستتلقى تنبيهاً عندما تنخفض الكمية عن هذا الحد',
  'inventory.restock': 'تعبئة المخزون',
  'inventory.restockMaterial': 'تعبئة مخزون',
  'inventory.adjustStock': 'تعديل المخزون',
  'inventory.newQuantity': 'الكمية الجديدة',
  'inventory.addQuantity': 'الكمية المضافة',
  'inventory.notes': 'ملاحظات',
  'inventory.notesPlaceholder': 'مثال: شراء مواد جديدة',
  'inventory.totalMaterials': 'إجمالي المواد',
  'inventory.inStock': 'متوفرة',
  'inventory.lowStock': 'منخفضة',
  'inventory.outOfStock': 'نفذت',
  'inventory.noMaterials': 'لا توجد مواد خام',
  'inventory.startAdding': 'ابدأ بإضافة المواد الخام المستخدمة في التحضير',
  'inventory.deleteMaterial': 'حذف المادة',
  'inventory.deleteConfirm': 'هل أنت متأكد من حذف المادة',
  'inventory.usedInTemplates': 'لا يمكن حذف المادة لأنها مستخدمة في قوالب تحضير',
  'inventory.movements': 'سجل الحركات',
  'inventory.movementHistory': 'سجل حركة المخزون',
  'inventory.unlimited': 'غير محدود',
  'inventory.searchPlaceholder': 'البحث عن مادة...',
  'inventory.statusFilter': 'حالة المخزون',
  'inventory.all': 'الكل',
  'inventory.createSuccess': 'تم إضافة المادة بنجاح',
  'inventory.updateSuccess': 'تم تحديث المادة بنجاح',
  'inventory.deleteSuccess': 'تم حذف المادة بنجاح',
  'inventory.restockSuccess': 'تم تعبئة المخزون بنجاح',
  'inventory.purchasePrice': 'السعر الإجمالي للشراء',
  'inventory.purchasePriceHint': 'المبلغ الكلي المدفوع للكمية المضافة',
  'inventory.pricePerUnit': 'سعر الوحدة',
  'inventory.totalPriceHint': 'المبلغ الكلي للكمية (سيتم حساب سعر الوحدة تلقائياً)',
  'inventory.totalValue': 'الإجمالي',
  'inventory.adjustSuccess': 'تم تعديل المخزون بنجاح',
  'inventory.viewMovements': 'عرض حركة المخزون',
  'inventory.movementType': 'نوع الحركة',
  'inventory.movementQty': 'الكمية',
  'inventory.movementDate': 'التاريخ والوقت',
  'inventory.movementNotes': 'الملاحظات',
  'inventory.movementStock': 'المخزون',
  'inventory.movementCost': 'التكلفة',
  'inventory.noMovements': 'لا توجد حركات مخزون مسجلة',
  'inventory.noMovementsHint': 'ستظهر حركات المخزون هنا عند إجراء عمليات شراء أو استخدام',
  'inventory.loadingMovements': 'جاري تحميل سجل الحركات...',
  'inventory.stockBefore': 'قبل',
  'inventory.stockAfter': 'بعد',
  'inventory.loadMore': 'عرض المزيد',
  'inventory.category': 'التصنيف',
  'inventory.categoryFilter': 'تصنيف المواد',
  'inventory.noCategory': 'بدون تصنيف',
  'inventory.categoryVegetables': 'خضروات',
  'inventory.categoryFruits': 'فواكه',
  'inventory.categoryMeats': 'لحوم',
  'inventory.categoryPoultry': 'دواجن',
  'inventory.categoryDairy': 'ألبان وبيض',
  'inventory.categoryGrains': 'حبوب ونشويات',
  'inventory.categoryLegumes': 'بقوليات',
  'inventory.categorySpices': 'بهارات وتوابل',
  'inventory.categoryOilsFats': 'زيوت ودهون',
  'inventory.categoryBeverages': 'مشروبات',
  'inventory.categoryOther': 'أخرى',
  'inventory.manageCategories': 'إدارة التصنيفات',
  'inventory.addCategory': 'إضافة تصنيف',
  'inventory.categoryCount': 'تصنيف',
  'inventory.newCategoryPlaceholder': 'اسم التصنيف الجديد...',
  'inventory.noCategories': 'لا توجد تصنيفات',
  'inventory.materialCount': 'مادة',
  'inventory.categoryCreateSuccess': 'تم إضافة التصنيف بنجاح',
  'inventory.categoryCreateFailed': 'فشل إضافة التصنيف',
  'inventory.categoryRenameSuccess': 'تم تعديل اسم التصنيف بنجاح',
  'inventory.categoryRenameFailed': 'فشل تعديل اسم التصنيف',
  'inventory.categoryDeleteSuccess': 'تم حذف التصنيف وجميع المواد التابعة بنجاح',
  'inventory.categoryDeleteFailed': 'فشل حذف التصنيف',
  'inventory.deleteCategoryConfirm': 'هل أنت متأكد من حذف هذا التصنيف؟',
  'inventory.deleteCategoryWarning': 'سيتم حذف جميع المواد التابعة لهذا التصنيف. لا يمكن التراجع عن هذا الإجراء.',

  // Units
  'units.kg': 'كيلوغرام',
  'units.g': 'غرام',
  'units.liter': 'لتر',
  'units.ml': 'مليلتر',
  'units.piece': 'قطعة',
  'units.kgShort': 'كغم',
  'units.gShort': 'غم',
  'units.literShort': 'لتر',
  'units.mlShort': 'مل',
  'units.pieceShort': 'قطعة',

  // Stock Movement Types
  'movement.order_deduction': 'خصم طلب',
  'movement.order_restore': 'استعادة طلب',
  'movement.manual_restock': 'تعبئة مخزون',
  'movement.manual_adjustment': 'تعديل يدوي',
  'movement.unreconciled_deficit': 'عجز غير مسجل',

  // Templates (Recipe Templates)
  'templates.title': 'قوالب التحضير',
  'templates.subtitle': 'إنشاء وإدارة وصفات الأطباق',
  'templates.addTemplate': 'إضافة قالب',
  'templates.editTemplate': 'تعديل القالب',
  'templates.templateName': 'اسم القالب',
  'templates.templateDescription': 'وصف القالب',
  'templates.ingredients': 'المكونات',
  'templates.addIngredient': 'إضافة مكون',
  'templates.selectMaterial': 'اختر المادة',
  'templates.ingredientQuantity': 'الكمية',
  'templates.ingredientUnit': 'الوحدة',
  'templates.noTemplates': 'لا توجد قوالب تحضير',
  'templates.startAdding': 'ابدأ بإنشاء قوالب لوصفات أطباقك',
  'templates.deleteTemplate': 'حذف القالب',
  'templates.deleteConfirm': 'هل أنت متأكد من حذف القالب',
  'templates.linkedDishes': 'الأطباق المرتبطة',
  'templates.cost': 'تكلفة المكونات',
  'templates.availability': 'توفر المكونات',
  'templates.available': 'متوفرة',
  'templates.notAvailable': 'غير متوفرة',
  'templates.ingredientsCount': 'مكون',
  'templates.costPerServing': 'التكلفة لكل حصة',
  'templates.searchPlaceholder': 'البحث عن قالب...',
  'templates.createSuccess': 'تم إنشاء القالب بنجاح',
  'templates.updateSuccess': 'تم تحديث القالب بنجاح',
  'templates.deleteSuccess': 'تم حذف القالب بنجاح',
  'templates.selectTemplate': 'اختر قالب التحضير',
  'templates.noTemplate': 'بدون قالب',
  'templates.templateLinked': 'قالب التحضير',

  // Settings Page
  'settings.title': 'الإعدادات',
  'settings.subtitle': 'إدارة إعدادات المطعم والنظام',
  'settings.section.profile': 'الملف الشخصي',
  'settings.section.profileDesc': 'تعديل معلومات المطعم والصور',
  'settings.section.menu': 'إعدادات المنيو',
  'settings.section.menuDesc': 'التحكم برابط المنيو وإعداداته',
  'settings.section.notifications': 'الإشعارات',
  'settings.section.notificationsDesc': 'إعدادات التنبيهات والإشعارات',
  'settings.section.about': 'حول النظام',
  'settings.section.aboutDesc': 'معلومات عن النظام والدعم',
  'settings.comingSoon': 'قريباً',
  'settings.comingSoonDesc': 'هذا القسم قيد التطوير وسيكون متاحاً قريباً',
  'settings.aboutVersion': 'الإصدار',
  'settings.aboutSupport': 'الدعم الفني',
  'settings.aboutSupportDesc': 'للمساعدة والدعم الفني تواصل معنا',

  // Offline / Sync
  'offline.banner.noConnection': 'لا يوجد اتصال بالإنترنت',
  'offline.banner.workingLocally': 'العمل مستمر محلياً',
  'offline.banner.pendingOps': '{{count}} عمليات بانتظار المزامنة',
  'offline.banner.syncing': 'جاري المزامنة…',
  'offline.banner.syncComplete': 'تمت المزامنة بنجاح',
  'offline.banner.syncFailed': 'فشلت {{count}} عمليات',
  'offline.banner.retry': 'إعادة المحاولة',
  'offline.badge.pendingSync': 'بانتظار المزامنة',
  'offline.badge.cachedData': 'بيانات محلية',
  'offline.order.tempNumber': 'رقم مؤقت',
  'offline.order.willSyncLater': 'سيتم المزامنة عند عودة الاتصال',
  'offline.order.synced': 'تمت المزامنة — رقم الطلب: {{orderNumber}}',
  'offline.order.createdOffline': 'تم إنشاء الطلب محلياً — سيتم المزامنة عند عودة الاتصال',
  'offline.staff.syncRequired': 'الموظف لن يتمكن من تسجيل الدخول حتى المزامنة',
  'offline.menu.cachedView': 'تعرض القائمة من آخر زيارة',
  'offline.file.pendingUpload': 'الصورة ستُرفع عند عودة الاتصال',
  'offline.sync.processing': 'جاري معالجة {{count}} عمليات…',
  'offline.sync.completed': 'تمت مزامنة {{count}} عمليات بنجاح',
  'offline.sync.partialFail': 'فشلت {{failed}} من {{total}} عمليات',
  'offline.sync.conflict': 'تم تحديث {{entity}} بالفعل من مستخدم آخر',
  'nav.notifications': 'الإشعارات والتنبيهات',
  'inventory.needsReconciliation': 'تسوية مخزون (تعبئة غير مسجلة)',

  // Onboarding & Learning Center
  'onboarding.welcome.title': 'مرحباً بك في نظام المطعم',
  'onboarding.welcome.description': 'ستقوم هذه الجولة التفاعلية بإرشادك خلال الإعداد الكامل لمطعمك. تعلم كيف تجهز المنيو، وتدير الموظفين، والمخزون، وتتابع أرباحك اليومية.',
  'onboarding.settings.title': '1. الإعدادات الأساسية',
  'onboarding.settings.description': 'ابدأ بزيارة صفحة الإعدادات. هنا يمكنك تعيين شعار مطعمك، أوقات العمل، وتحديد مناطق التوصيل. تستخدم مناطق التوصيل نظام تحديد المواقع لضمان عدم تمكن العملاء من الطلب إلا إذا كانوا ضمن المناطق المحددة.',
  'onboarding.staff.title': '2. الموظفون والصلاحيات',
  'onboarding.staff.description': 'لا تشارك حساب المالك الخاص بك أبداً! اذهب إلى صفحة الموظفين لإنشاء حسابات فردية للكاشير، والويتر، والمحاسب، ومدير المخزون. كل دور يرى فقط ما يحتاجه للقيام بعمله.',
  'onboarding.menu.title': '3. المنيو وقاعدة التسعير',
  'onboarding.menu.description': 'أنشئ الفئات ثم أضف الأطباق. هام جداً: جميع الأسعار تستخدم قاعدة "x1000". إذا كانت الوجبة بسعر 15,000 دينار عراقي، ببساطة اكتب "15". يمكنك أيضاً إضافة الإضافات بأسعارها وكمياتها المجانية.',
  'onboarding.inventory.title': '4. المخزون والوصفات',
  'onboarding.inventory.description': 'لجعل النظام يخصم المخزون تلقائياً عند بيع الوجبات، يجب عليك إنشاء المواد الأولية (المخزون) ثم ربطها بالطبق باستخدام "قوالب التحضير". هذا يحسب أيضاً التكلفة الدقيقة لطعامك.',
  'onboarding.delivery.title': '5. شركات التوصيل',
  'onboarding.delivery.description': 'إذا كنت تستخدم تطبيقات خارجية مثل طلبات أو توترز، أضفها في قسم شركات التوصيل. سيقوم النظام تلقائياً بحساب عمولاتهم وخصوماتهم ليكون صافي ربحك دقيقاً دائماً.',
  'onboarding.pos.title': '6. صندوق النقد (الكاشير)',
  'onboarding.pos.description': 'لا يمكن للكاشير استلام الطلبات حتى يقوم المدير بفتح "صندوق النقد" له. تنتقل الطلبات من قيد الانتظار ← مؤكد ← مكتمل. عند انقطاع الإنترنت، يستمر النظام بالعمل دون اتصال ويزامن لاحقاً.',
  'onboarding.reports.title': '7. التقارير ونهاية اليوم',
  'onboarding.reports.description': 'في الليل، أغلق صناديق النقد للتحقق من وجود أي نقص في الأموال. سجل مصاريفك اليومية، وافحص تقرير الأرباح والخسائر لترى هامش الربح الصافي الدقيق لليوم. أنت الآن جاهز للعمل!',
  'onboarding.next': 'التالي',
  'onboarding.back': 'السابق',
  'onboarding.skip': 'تخطي الجولة والذهاب إلى لوحة التحكم',
  'onboarding.finish': 'ابدأ العمل',
  
  'onboarding.complete.title': 'اكتمل الإعداد بنجاح!',
  'onboarding.complete.description': 'أنت الآن جاهز لإدارة مطعمك بكفاءة. يمكنك دائماً العودة إلى "مركز التعليم" في القائمة الجانبية لإعادة الجولة أو قراءة المزيد من التعليمات.',
  
  'learning.title': 'مركز التعليم',
  'learning.subtitle': 'أدلة الاستخدام، التعليمات، ودليل العمليات',
  'learning.restartTour': 'إعادة الجولة التفاعلية',
  'learning.owner.advanced.title': 'الميزات المتقدمة',
  'learning.owner.advanced.pricing.title': 'قاعدة التسعير x1000',
  'learning.owner.advanced.pricing.content': 'لتسهيل إدخال البيانات، يتم ضرب جميع الأسعار في 1000. أدخل 5 بدلاً من 5,000 دينار.',
  'learning.owner.advanced.templates.title': 'قوالب التحضير',
  'learning.owner.advanced.templates.content': 'ربط مكونات المواد الخام بطبق واحد لخصم المخزون تلقائياً.',
  'learning.owner.advanced.deliveryZones.title': 'مناطق التوصيل',
  'learning.owner.advanced.deliveryZones.content': 'إعداد مناطق التوصيل في الإعدادات لحساب رسوم التوصيل تلقائياً في نقطة البيع.',
  'learning.owner.tips.title': 'نصائح وأفضل الممارسات',
  'learning.owner.tips.best.title': 'أفضل الممارسات',
  'learning.owner.tips.best.content': 'سجل المصاريف يومياً. وقم بمطابقة صناديق النقد في نهاية كل وردية بدقة.',
  'learning.owner.tips.mistakes.title': 'أخطاء شائعة',
  'learning.owner.tips.mistakes.content': 'نسيان ربط المواد الخام بالأطباق، مما يمنع الخصم التلقائي للمخزون.',
  'learning.owner.faq.title': 'الأسئلة الشائعة',
  'learning.owner.faq.q1.title': 'لماذا لا يستطيع الكاشير إضافة طلبات؟',
  'learning.owner.faq.q1.content': 'يحتاج إلى وردية صندوق نقد مفتوحة. قم بفتح واحدة له من صفحة صندوق النقد.',
  'learning.owner.faq.q2.title': 'كيف يعمل وضع عدم الاتصال؟',
  'learning.owner.faq.q2.content': 'إذا انقطع الإنترنت، يمكن للكاشير الاستمرار في تلقي الطلبات. سيقوم النظام بالمزامنة تلقائياً عند عودة الاتصال.',
  'learning.owner.faq.q3.title': 'هل يمكن للويتر حذف الطلبات؟',
  'learning.owner.faq.q3.content': 'لا، يمكن للويتر فقط إرسال طلبات معلقة. يجب على الكاشير تأكيدها أو إلغاؤها.',
  'learning.owner.troubleshooting.title': 'استكشاف الأخطاء وإصلاحها',
  'learning.owner.troubleshooting.offline.title': 'مشاكل المزامنة بدون اتصال',
  'learning.owner.troubleshooting.offline.content': 'إذا ظهر شريط عدم الاتصال بكلمة "بانتظار المزامنة"، اترك التطبيق مفتوحاً حتى يعود الإنترنت.',
  'learning.owner.troubleshooting.print.title': 'مشاكل الطابعة',
  'learning.owner.troubleshooting.print.content': 'تأكد من تشغيل أداة Print Server على جهاز الكمبيوتر المتصل بالطابعات.',
  'learning.owner.whatsNew.title': 'ما الجديد',
  'learning.owner.whatsNew.latest.title': 'آخر التحديثات',
  'learning.owner.whatsNew.latest.content': 'تمت إضافة مركز تعليم مبني على الأدوار وجولات تعريفية تفاعلية.',
  'learning.cashier.gettingStarted.firstLogin.title': 'تسجيل الدخول الأول',
  'learning.cashier.gettingStarted.firstLogin.content': 'تعرف على واجهة نقطة البيع. ملاحظة: لا يمكنك استلام الطلبات حتى يقوم المدير بفتح الصندوق الخاص بك.',
  'learning.cashier.dashboard.title': 'لوحة التحكم',
  'learning.cashier.dashboard.overview.title': 'واجهة نقطة البيع',
  'learning.cashier.dashboard.overview.content': 'تنقسم نقطة البيع إلى الفئات (يسار)، الأطباق (وسط)، وتذكرة الطلب الحالي (يمين).',
  'learning.cashier.dailyWorkflow.opening.title': 'الافتتاح',
  'learning.cashier.dailyWorkflow.opening.content': 'تأكد من أن درج النقود يطابق المبلغ الافتتاحي المحدد من قبل المدير.',
  'learning.cashier.dailyWorkflow.taking.title': 'أثناء الوردية',
  'learning.cashier.dailyWorkflow.taking.content': 'استلم الطلبات المباشرة، أكد طلبات الويترز في تبويب الطلبات، وأدر الطاولات.',
  'learning.cashier.features.scheduling.title': 'الجدولة',
  'learning.cashier.features.scheduling.content': 'إذا نفد أحد العناصر من المطبخ، قم بإيقافه من هنا ليختفي من نقطة البيع وأجهزة الويترز.',
  'learning.cashier.features.inventory.title': 'المخزون',
  'learning.cashier.features.inventory.content': 'اعرض مستويات المخزون الحالية للإجابة على أسئلة العملاء حول التوفر.',
  'learning.cashier.commonTasks.title': 'المهام الشائعة',
  'learning.cashier.commonTasks.newOrder.title': 'استلام طلب',
  'learning.cashier.commonTasks.newOrder.content': 'اختر نوع الطلب، انقر على العناصر، اضغط دفع، أدخل المبلغ المستلم، وأعطِ الباقي.',
  'learning.cashier.commonTasks.confirmWaiter.title': 'تأكيد طلبات الويتر',
  'learning.cashier.commonTasks.confirmWaiter.content': 'اذهب إلى الطلبات، ابحث عن الطلبات المعلقة، راجع العناصر، وانقر تأكيد لطباعة تذاكر المطبخ.',
  'learning.cashier.commonTasks.refund.title': 'المسترجعات',
  'learning.cashier.commonTasks.refund.content': 'ابحث عن الطلب المكتمل في قائمة الطلبات وانقر استرجاع (يتطلب صلاحية).',
  'learning.cashier.tips.title': 'نصائح',
  'learning.cashier.tips.best.title': 'نصائح السرعة',
  'learning.cashier.tips.best.content': 'استخدم شريط البحث في نقطة البيع للعثور السريع على العناصر. راقب شارة الطلبات لمعرفة طلبات الويترز الجديدة.',
  'learning.cashier.tips.mistakes.title': 'أخطاء يجب تجنبها',
  'learning.cashier.tips.mistakes.content': 'نسيان تحديد منطقة التوصيل لطلبات التوصيل، مما يؤدي إلى إجمالي مبالغ غير صحيح.',
  'learning.cashier.faq.title': 'الأسئلة الشائعة',
  'learning.cashier.faq.q1.title': 'لماذا الشاشة صفراء؟',
  'learning.cashier.faq.q1.content': 'أنت غير متصل بالإنترنت. يمكنك الاستمرار في تلقي الطلبات. لا تغلق التطبيق.',
  'learning.cashier.faq.q2.title': 'أتلقى خطأ في صندوق النقد.',
  'learning.cashier.faq.q2.content': 'ورديتك مغلقة. اطلب من المدير فتحها.',
  'learning.cashier.faq.q3.title': 'كيف أضيف ملاحظة للطبق؟',
  'learning.cashier.faq.q3.content': 'انقر على الطبق في تذكرة الطلب الحالية لفتح الخيارات وإضافة ملاحظات مثل "بدون فلفل".',
  'learning.cashier.troubleshooting.title': 'استكشاف الأخطاء وإصلاحها',
  'learning.cashier.troubleshooting.offline.title': 'وضع عدم الاتصال',
  'learning.cashier.troubleshooting.offline.content': 'إذا توقفت الطابعة عن العمل في وضع عدم الاتصال، تحقق من اتصال الشبكة المحلية.',
  'learning.cashier.troubleshooting.registerClosed.title': 'إغلاق الصندوق منتصف الوردية',
  'learning.cashier.troubleshooting.registerClosed.content': 'إذا أغلق المدير ورديتك عن طريق الخطأ، يجب عليه فتح وردية جديدة لك للمتابعة.',
  'learning.cashier.whatsNew.title': 'ما الجديد',
  'learning.cashier.whatsNew.latest.title': 'التحديثات',
  'learning.cashier.whatsNew.latest.content': 'تمت إضافة أدلة خاصة بالأدوار.',
  'learning.accountant.gettingStarted.firstLogin.title': 'الخطوات الأولى',
  'learning.accountant.gettingStarted.firstLogin.content': 'راجع لوحة التحكم لفهم التدفق النقدي اليومي والمطابقات المعلقة.',
  'learning.accountant.dashboard.title': 'لوحة التحكم',
  'learning.accountant.dashboard.overview.title': 'نظرة عامة مالية',
  'learning.accountant.dashboard.overview.content': 'عرض سريع لإيرادات اليوم والمصاريف وصافي الربح.',
  'learning.accountant.features.dashboard.title': 'لوحة التحكم',
  'learning.accountant.features.dashboard.content': 'ملخص مالي عالي المستوى.',
  'learning.accountant.features.deliveryCompanies.title': 'شركات التوصيل',
  'learning.accountant.features.deliveryCompanies.content': 'إدارة نسب العمولة لحساب الإيرادات الصافية لطلبات التوصيل الخارجية بشكل صحيح.',
  'learning.accountant.features.orders.title': 'الطلبات',
  'learning.accountant.features.orders.content': 'وصول للعرض فقط لمراجعة المعاملات الفردية.',
  'learning.accountant.features.inventory.title': 'المخزون',
  'learning.accountant.features.inventory.content': 'وصول للعرض فقط لمراجعة تقييم المخزون وتكلفة البضائع المباعة.',
  'learning.accountant.commonTasks.title': 'المهام الشائعة',
  'learning.accountant.commonTasks.closeRegister.title': 'مطابقة الوردية',
  'learning.accountant.commonTasks.closeRegister.content': 'انقر إغلاق الوردية، وأدخل النقد المحسوب. سجل أي نقص أو زيادة.',
  'learning.accountant.commonTasks.addExpense.title': 'تسجيل المصروفات',
  'learning.accountant.commonTasks.addExpense.content': 'اذهب إلى المصاريف، انقر إضافة، اختر الفئة، أدخل المبلغ وأرفق صورة الفاتورة إذا لزم الأمر.',
  'learning.accountant.commonTasks.generateReport.title': 'توليد تقرير الأرباح والخسائر',
  'learning.accountant.commonTasks.generateReport.content': 'اذهب إلى التقارير، اختر الأرباح والخسائر، حدد النطاق الزمني واعرض الهامش الصافي.',
  'learning.accountant.tips.title': 'نصائح',
  'learning.accountant.tips.best.title': 'أفضل الممارسات',
  'learning.accountant.tips.best.content': 'سجل المصاريف في الوقت الفعلي. لا تؤجلها لنهاية الشهر لضمان دقة التقارير.',
  'learning.accountant.tips.mistakes.title': 'أخطاء يجب تجنبها',
  'learning.accountant.tips.mistakes.content': 'إغلاق وردية دون حساب الصندوق فعلياً أولاً.',
  'learning.accountant.faq.title': 'الأسئلة الشائعة',
  'learning.accountant.faq.q1.title': 'لماذا صافي الربح أقل من المتوقع؟',
  'learning.accountant.faq.q1.content': 'تأكد من دقة تكلفة البضائع المباعة (قوالب التحضير) وتسجيل جميع المصروفات.',
  'learning.accountant.faq.q2.title': 'كيف يتم التعامل مع عمولات التوصيل؟',
  'learning.accountant.faq.q2.content': 'يخصمها النظام تلقائياً من الإيرادات قبل حساب صافي الربح.',
  'learning.accountant.troubleshooting.title': 'استكشاف الأخطاء وإصلاحها',
  'learning.accountant.troubleshooting.mismatch.title': 'عدم تطابق النقد',
  'learning.accountant.troubleshooting.mismatch.content': 'إذا كان الصندوق ناقصاً، راجع سجلات الاسترجاع والخصم الخاصة بالكاشير في التقارير.',
  'learning.accountant.whatsNew.title': 'ما الجديد',
  'learning.accountant.whatsNew.latest.title': 'التحديثات',
  'learning.accountant.whatsNew.latest.content': 'تمت إضافة أدلة المحاسب.',
  'learning.inventoryManager.gettingStarted.firstLogin.title': 'الخطوات الأولى',
  'learning.inventoryManager.gettingStarted.firstLogin.content': 'راجع مستويات المخزون الحالية وتحقق من الإشعارات لأي حالات مخزون سلبي شاذة.',
  'learning.inventoryManager.dailyWorkflow.closing.title': 'الإغلاق',
  'learning.inventoryManager.dailyWorkflow.closing.content': 'راجع أي حالات شاذة في المخزون (مخزون سلبي) حدثت خلال اليوم.',
  'learning.inventoryManager.features.materials.title': 'المخزون (المواد)',
  'learning.inventoryManager.features.materials.content': 'أدر جميع المواد الخام. قم بتعيين تكلفة الوحدة وحد التنبيه للمخزون المنخفض.',
  'learning.inventoryManager.features.restock.title': 'إعادة التخزين',
  'learning.inventoryManager.features.restock.content': 'أضف الكميات المشتراة حديثاً إلى المخزون الحالي.',
  'learning.inventoryManager.commonTasks.title': 'المهام الشائعة',
  'learning.inventoryManager.commonTasks.addMaterial.title': 'إضافة مادة',
  'learning.inventoryManager.commonTasks.addMaterial.content': 'انقر إضافة مادة. حدد الوحدة (كجم، صندوق، حبة)، التكلفة، وحد التنبيه.',
  'learning.inventoryManager.commonTasks.restock.title': 'إعادة التخزين',
  'learning.inventoryManager.commonTasks.restock.content': 'اختر مادة، انقر تعديل، وأضف الكمية الجديدة إلى المخزون الحالي.',
  'learning.inventoryManager.commonTasks.fixAnomaly.title': 'إصلاح الحالات الشاذة',
  'learning.inventoryManager.commonTasks.fixAnomaly.content': 'إذا أصبح المخزون سلبياً، اذهب إلى الإشعارات وانقر إعادة تخزين النواقص لتصفيره وتسجيل التكلفة المفقودة.',
  'learning.inventoryManager.tips.title': 'نصائح',
  'learning.inventoryManager.tips.best.title': 'أفضل الممارسات',
  'learning.inventoryManager.tips.best.content': 'قم بجرد فعلي أسبوعياً لضمان تطابق النظام مع الواقع.',
  'learning.inventoryManager.tips.mistakes.title': 'أخطاء يجب تجنبها',
  'learning.inventoryManager.tips.mistakes.content': 'إعداد وحدات غير صحيحة في قوالب التحضير (مثلاً استخدام 1 كجم بدلاً من 0.1 كجم للبرجر).',
  'learning.inventoryManager.faq.title': 'الأسئلة الشائعة',
  'learning.inventoryManager.faq.q1.title': 'لماذا لا يتم خصم المخزون؟',
  'learning.inventoryManager.faq.q1.content': 'ربما لم تقم بربط المادة بالطبق في قوالب التحضير.',
  'learning.inventoryManager.faq.q2.title': 'ما هو المخزون السلبي؟',
  'learning.inventoryManager.faq.q2.content': 'عند بيع طبق والنظام يعتقد أنه لديك صفر مكونات. يصبح بالسالب لتنبيهك أنك نسيت تسجيل التخزين.',
  'learning.inventoryManager.troubleshooting.title': 'استكشاف الأخطاء وإصلاحها',
  'learning.inventoryManager.troubleshooting.negative.title': 'مخزون سلبي جماعي',
  'learning.inventoryManager.troubleshooting.negative.content': 'إذا كانت عناصر كثيرة سلبية، راجع سجلات الشراء. استخدم ميزة إعادة التخزين الجماعي في الإشعارات.',
  'learning.inventoryManager.whatsNew.title': 'ما الجديد',
  'learning.inventoryManager.whatsNew.latest.title': 'التحديثات',
  'learning.inventoryManager.whatsNew.latest.content': 'تمت إضافة أدلة المخزون.',
  'learning.deliveryCashier.gettingStarted.firstLogin.title': 'الخطوات الأولى',
  'learning.deliveryCashier.gettingStarted.firstLogin.content': 'تعرف على تبويب شركات التوصيل في نقطة البيع.',
  'learning.deliveryCashier.dailyWorkflow.receiving.title': 'استلام الطلبات',
  'learning.deliveryCashier.dailyWorkflow.receiving.content': 'عندما يرن الجهاز الخارجي، أدخل الطلب في هذا النظام فوراً.',
  'learning.deliveryCashier.dailyWorkflow.processing.title': 'المعالجة',
  'learning.deliveryCashier.dailyWorkflow.processing.content': 'تأكد من إدخال رقم الطلب بشكل صحيح للتتبع.',
  'learning.deliveryCashier.dailyWorkflow.tracking.title': 'التتبع',
  'learning.deliveryCashier.dailyWorkflow.tracking.content': 'راقب صفحة طلبات التوصيل لإرسال السائقين.',
  'learning.deliveryCashier.commonTasks.title': 'المهام الشائعة',
  'learning.deliveryCashier.commonTasks.newDeliveryOrder.title': 'إدخال طلب',
  'learning.deliveryCashier.commonTasks.newDeliveryOrder.content': 'افتح نقطة البيع > اختر الشركة > أدخل رقم الطلب > أضف العناصر > تأكيد.',
  'learning.deliveryCashier.commonTasks.trackOrder.title': 'إرسال السائق',
  'learning.deliveryCashier.commonTasks.trackOrder.content': 'اذهب إلى طلبات التوصيل وحدّث الحالة عندما يستلم السائق الطعام.',
  'learning.deliveryCashier.tips.title': 'نصائح',
  'learning.deliveryCashier.tips.best.title': 'السرعة',
  'learning.deliveryCashier.tips.best.content': 'أدخل الطلبات تماماً كما تظهر على الجهاز الخارجي لضمان دقة المطبخ.',
  'learning.deliveryCashier.tips.mistakes.title': 'أخطاء يجب تجنبها',
  'learning.deliveryCashier.tips.mistakes.content': 'إدخال طلب توصيل كطلب صالة عادي. هذا يفسد حساب العمولات.',
  'learning.deliveryCashier.faq.title': 'الأسئلة الشائعة',
  'learning.deliveryCashier.faq.q1.title': 'لماذا يجب عليّ تحديد الشركة؟',
  'learning.deliveryCashier.faq.q1.content': 'ليتمكن النظام من حساب عمولتهم تلقائياً وإظهار ربحنا الحقيقي.',
  'learning.deliveryCashier.troubleshooting.title': 'استكشاف الأخطاء وإصلاحها',
  'learning.deliveryCashier.troubleshooting.companyMissing.title': 'الشركة غير مدرجة',
  'learning.deliveryCashier.troubleshooting.companyMissing.content': 'إذا كان تطبيق التوصيل مفقوداً في نقطة البيع، اطلب من المدير إضافته في الإعدادات > شركات التوصيل.',
  'learning.deliveryCashier.whatsNew.title': 'ما الجديد',
  'learning.deliveryCashier.whatsNew.latest.title': 'التحديثات',
  'learning.deliveryCashier.whatsNew.latest.content': 'تمت إضافة أدلة كاشير التوصيل.',
  'learning.roleName.owner': 'مالك المطعم',
  'learning.roleName.cashier': 'كاشير',
  'learning.roleName.accountant': 'محاسب',
  'learning.roleName.inventoryManager': 'مدير المخزون',
  'learning.roleName.deliveryCashier': 'كاشير التوصيل',
  'onboarding.owner.welcome.title': 'مرحباً بك في نظام إدارة المطاعم',
  'onboarding.owner.welcome.description': 'بصفتك المالك، لديك سيطرة كاملة على المطعم. دعنا نأخذ جولة سريعة في لوحة التحكم والميزات.',
  'onboarding.owner.settings.title': 'الإعدادات',
  'onboarding.owner.settings.description': 'قم بتكوين تفاصيل مطعمك، والشعار، وطباعة الإيصالات، ومناطق التوصيل هنا.',
  'onboarding.owner.staff.title': 'إدارة الموظفين',
  'onboarding.owner.staff.description': 'أضف الموظفين وقم بتعيين أدوارهم (كاشير، محاسب، إلخ).',
  'onboarding.owner.menu.title': 'المنيو والفئات',
  'onboarding.owner.menu.description': 'أنشئ فئاتك وأطباقك. تذكر قاعدة التسعير x1000!',
  'onboarding.owner.inventory.title': 'المخزون',
  'onboarding.owner.inventory.description': 'إدارة المواد الخام وتتبع مستويات المخزون.',
  'onboarding.owner.delivery.title': 'شركات التوصيل',
  'onboarding.owner.delivery.description': 'أضف تطبيقات التوصيل الخارجية لتتبع عمولاتهم بدقة.',
  'onboarding.owner.pos.title': 'نقطة البيع (POS)',
  'onboarding.owner.pos.description': 'الواجهة الرئيسية للكاشير لتلقي الطلبات.',
  'onboarding.owner.reports.title': 'التقارير',
  'onboarding.owner.reports.description': 'عرض الأرباح والخسائر، تحليلات المبيعات، وتقارير نهاية اليوم.',
  'onboarding.owner.complete.title': 'اكتملت الجولة!',
  'onboarding.owner.complete.description': 'أنت جاهز لإدارة مطعمك. قم بزيارة مركز التعليم في أي وقت للحصول على أدلة تفصيلية.',
  'onboarding.cashier.welcome.title': 'مرحباً كاشير',
  'onboarding.cashier.welcome.description': 'دعنا نأخذ جولة سريعة في نقطة البيع وأدواتك اليومية.',
  'onboarding.cashier.pos.title': 'نقطة البيع',
  'onboarding.cashier.pos.description': 'استلم طلبات الصالة (الداين-إن) والتوصيل من هنا.',
  'onboarding.cashier.orders.title': 'الطلبات',
  'onboarding.cashier.orders.description': 'إدارة الطلبات النشطة وتأكيد طلبات الويترز.',
  'onboarding.cashier.tables.title': 'الطاولات',
  'onboarding.cashier.tables.description': 'عرض حالة الطاولات وتعيين الطلبات لها.',
  'onboarding.cashier.scheduling.title': 'الجدولة',
  'onboarding.cashier.scheduling.description': 'إيقاف الأطباق مؤقتاً إذا نفدت الكمية أثناء ورديتك.',
  'onboarding.cashier.inventory.title': 'المخزون',
  'onboarding.cashier.inventory.description': 'التحقق من مستويات مخزون المواد الخام.',
  'onboarding.cashier.complete.title': 'جاهز للعمل!',
  'onboarding.cashier.complete.description': 'أنت جاهز لاستلام الطلبات. تحقق من مركز التعليم إذا احتجت إلى مساعدة.',
  'onboarding.accountant.welcome.title': 'مرحباً بك، محاسب',
  'onboarding.accountant.welcome.description': 'إليك أدواتك للإدارة المالية.',
  'onboarding.accountant.dashboard.title': 'لوحة المحاسب',
  'onboarding.accountant.dashboard.description': 'نظرة عامة على المقاييس المالية لليوم.',
  'onboarding.accountant.expenses.title': 'المصاريف',
  'onboarding.accountant.expenses.description': 'تسجيل المصاريف اليومية لحساب الأرباح والخسائر بدقة.',
  'onboarding.accountant.cashRegister.title': 'صندوق النقد',
  'onboarding.accountant.cashRegister.description': 'فتح الورديات للكاشير وتسوية النقد في نهاية اليوم.',
  'onboarding.accountant.reports.title': 'التقارير',
  'onboarding.accountant.reports.description': 'إنشاء تقارير الأرباح والخسائر والمبيعات.',
  'onboarding.accountant.deliveryCompanies.title': 'شركات التوصيل',
  'onboarding.accountant.deliveryCompanies.description': 'إدارة عمولات شركات التوصيل الخارجية.',
  'onboarding.accountant.inventory.title': 'المخزون',
  'onboarding.accountant.inventory.description': 'مراقبة قيم وتكاليف المخزون.',
  'onboarding.accountant.complete.title': 'اكتمل الإعداد',
  'onboarding.accountant.complete.description': 'أنت جاهز لإدارة الشؤون المالية.',
  'onboarding.inventoryManager.welcome.title': 'مرحباً، مدير المخزون',
  'onboarding.inventoryManager.welcome.description': 'أدواتك للمخزون والوصفات.',
  'onboarding.inventoryManager.inventory.title': 'المخزون',
  'onboarding.inventoryManager.inventory.description': 'إضافة المواد الخام وتحديث كميات المخزون.',
  'onboarding.inventoryManager.templates.title': 'قوالب التحضير',
  'onboarding.inventoryManager.templates.description': 'ربط المواد الخام بالأطباق ليتم خصم المخزون تلقائياً.',
  'onboarding.inventoryManager.notifications.title': 'الإشعارات',
  'onboarding.inventoryManager.notifications.description': 'تحقق هنا من تحذيرات انخفاض المخزون وشوائب المخزون السلبي.',
  'onboarding.inventoryManager.complete.title': 'جاهز!',
  'onboarding.inventoryManager.complete.description': 'أنت جاهز لإدارة المخزون.',
  'onboarding.deliveryCashier.welcome.title': 'مرحباً، كاشير التوصيل',
  'onboarding.deliveryCashier.welcome.description': 'نظام الكاشير المخصص لطلبات التوصيل الخارجية.',
  'onboarding.deliveryCashier.pos.title': 'نقطة البيع (POS)',
  'onboarding.deliveryCashier.pos.description': 'إدخال طلبات طلبات، توترز، إلخ.',
  'onboarding.deliveryCashier.deliveryOrders.title': 'طلبات التوصيل',
  'onboarding.deliveryCashier.deliveryOrders.description': 'تتبع وإدارة إرسال الطلبات للسائقين.',
  'onboarding.deliveryCashier.complete.title': 'جاهز!',
  'onboarding.deliveryCashier.complete.description': 'أنت جاهز لمعالجة طلبات التوصيل.',
  'learning.owner.navigation.title': 'دليل التنقل',
  'learning.owner.navigation.sidebar.title': 'الشريط الجانبي',
  'learning.owner.navigation.sidebar.content': 'استخدم الشريط الجانبي الأيسر للتنقل. في الهاتف المحمول، انقر على أيقونة القائمة لفتحه.',
  'learning.owner.dailyWorkflow.title': 'سير العمل اليومي',
  'learning.owner.dailyWorkflow.morning.title': 'الصباح',
  'learning.owner.dailyWorkflow.morning.content': 'تحقق من الإشعارات بشأن انخفاض المخزون. تأكد من فتح صناديق النقد للكاشير (أو اجعل المحاسب يقوم بذلك).',
  'learning.owner.dailyWorkflow.during.title': 'أثناء الوردية',
  'learning.owner.dailyWorkflow.during.content': 'راقب الطلبات المباشرة. استخدم صفحة الجدولة لإيقاف الأطباق إذا نفدت المكونات.',
  'learning.owner.dailyWorkflow.closing.title': 'الإغلاق',
  'learning.owner.dailyWorkflow.closing.content': 'تأكد من إغلاق جميع الصناديق. تحقق من تقرير الأرباح والخسائر لمعرفة أداء اليوم.',
  'learning.owner.features.title': 'دليل الميزات',
  'learning.owner.features.settings.title': 'الإعدادات',
  'learning.owner.features.settings.content': 'إدارة ملف تعريف المطعم، تفضيلات الطباعة، ونسب الضرائب.',
  'learning.owner.features.staff.title': 'الموظفون',
  'learning.owner.features.staff.content': 'إضافة الموظفين. لكل دور أذونات محددة. يمكن للويترز فقط تلقي الطلبات.',
  'learning.owner.features.menu.title': 'المنيو',
  'learning.owner.features.menu.content': 'تنظيم الأطباق في فئات. إضافة إضافات (مثل الأحجام أو الإضافات الإضافية).',
  'learning.owner.features.inventory.title': 'المخزون',
  'learning.owner.features.inventory.content': 'تتبع المواد الخام. يتم خصم المخزون تلقائيًا عند بيع الوجبات (إذا تم تكوين القوالب).',
  'learning.owner.features.pos.title': 'نقطة البيع (POS)',
  'learning.owner.features.pos.content': 'نقطة البيع هي المكان الذي يعالج فيه الكاشير طلبات الصالة والتوصيل.',
  'learning.owner.features.tables.title': 'الطاولات',
  'learning.owner.features.tables.content': 'إدارة تخطيط وحالة طاولات الصالة.',
  'learning.owner.features.delivery.title': 'شركات التوصيل',
  'learning.owner.features.delivery.content': 'إضافة تطبيقات مثل طلبات. يقوم النظام بحساب عمولتهم لإظهار صافي ربحك الحقيقي.',
  'learning.owner.features.reports.title': 'التقارير',
  'learning.owner.features.reports.content': 'تحليلات تفصيلية بما في ذلك الأرباح والخسائر، نهاية اليوم، والمبيعات حسب الصنف.',
  'learning.owner.features.expenses.title': 'المصاريف',
  'learning.owner.features.expenses.content': 'سجل التكاليف اليومية (الإيجار، المرافق، البقالة) لحساب صافي الربح الدقيق.',
  'learning.owner.features.scheduling.title': 'الجدولة',
  'learning.owner.features.scheduling.content': 'تمكين/تعطيل الأطباق بسرعة دون حذفها من المنيو.',
  'learning.owner.commonTasks.title': 'المهام الشائعة',
  'learning.owner.commonTasks.addDish.title': 'إضافة طبق',
  'learning.owner.commonTasks.addDish.content': 'انتقل إلى المنيو > اختر الفئة > إضافة طبق. أدخل السعر (مثال: 15 لـ 15,000).',
  'learning.owner.commonTasks.addStaff.title': 'إضافة موظفين',
  'learning.owner.commonTasks.addStaff.content': 'انتقل إلى الموظفين > إضافة موظف. قم بتوفير اسم مستخدم. يضيف النظام معرف مطعمك تلقائيًا.',
  'learning.owner.commonTasks.openRegister.title': 'فتح صندوق النقد',
  'learning.owner.commonTasks.openRegister.content': 'انتقل إلى صندوق النقد > فتح وردية. أدخل المبلغ النقدي الابتدائي.',
  'learning.cashier.gettingStarted.title': 'البدء',
  'learning.cashier.gettingStarted.purpose.title': 'دورك',
  'learning.cashier.gettingStarted.purpose.content': 'أنت تدير نقطة البيع، وتعالج المدفوعات، وتؤكد الطلبات المرسلة من قبل الويترز.',
  'learning.cashier.dailyWorkflow.title': 'سير العمل اليومي',
  'learning.cashier.dailyWorkflow.closing.title': 'الإغلاق',
  'learning.cashier.dailyWorkflow.closing.content': 'احسب الدرج الخاص بك وسلم النقدية للمدير/المحاسب لإغلاق الوردية.',
  'learning.cashier.features.title': 'الميزات',
  'learning.cashier.features.pos.title': 'نقطة البيع',
  'learning.cashier.features.pos.content': 'انقر على العناصر لإضافتها. اختر صالة، سفري، أو توصيل. قم بتطبيق الخصومات إذا كان مصرحًا لك بذلك.',
  'learning.cashier.features.orders.title': 'الطلبات',
  'learning.cashier.features.orders.content': 'عرض جميع الطلبات النشطة. تظهر الطلبات المعلقة من الويترز هنا وتتطلب تأكيدك.',
  'learning.cashier.features.tables.title': 'الطاولات',
  'learning.cashier.features.tables.content': 'عرض الطاولات المشغولة ومعالجة المدفوعات لها.',
  'learning.accountant.gettingStarted.title': 'البدء',
  'learning.accountant.gettingStarted.purpose.title': 'دورك',
  'learning.accountant.gettingStarted.purpose.content': 'أنت تشرف على الصحة المالية للمطعم، وتسوّي النقد، وتدير المصاريف.',
  'learning.accountant.dailyWorkflow.title': 'سير العمل اليومي',
  'learning.accountant.dailyWorkflow.morning.title': 'الصباح',
  'learning.accountant.dailyWorkflow.morning.content': 'افتح ورديات صندوق النقد للكاشير مع رصيدهم الافتتاحي.',
  'learning.accountant.dailyWorkflow.during.title': 'أثناء الوردية',
  'learning.accountant.dailyWorkflow.during.content': 'سجل المصاريف التشغيلية (مدفوعات الموردين، المرافق) عند حدوثها.',
  'learning.accountant.dailyWorkflow.closing.title': 'الإغلاق',
  'learning.accountant.dailyWorkflow.closing.content': 'أغلق ورديات الكاشير، واحسب النقد الفعلي، وراجع تقرير الأرباح والخسائر اليومي.',
  'learning.accountant.features.title': 'الميزات',
  'learning.accountant.features.expenses.title': 'المصاريف',
  'learning.accountant.features.expenses.content': 'سجل كل الأموال الصادرة. ضروري لحساب الربح الدقيق.',
  'learning.accountant.features.cashRegister.title': 'صندوق النقد',
  'learning.accountant.features.cashRegister.content': 'إدارة الورديات. يقارن النظام النقد المتوقع للنظام مقابل النقد الفعلي.',
  'learning.accountant.features.reports.title': 'التقارير',
  'learning.accountant.features.reports.content': 'إنشاء تقارير الأرباح والخسائر، نهاية اليوم، والضرائب. قابلة للتصدير إلى PDF/Excel.',
  'learning.inventoryManager.gettingStarted.title': 'البدء',
  'learning.inventoryManager.gettingStarted.purpose.title': 'دورك',
  'learning.inventoryManager.gettingStarted.purpose.content': 'أنت تضمن عدم نفاد المكونات في المطعم وتتتبع تكاليف الطعام بدقة.',
  'learning.inventoryManager.dailyWorkflow.title': 'سير العمل اليومي',
  'learning.inventoryManager.dailyWorkflow.morning.title': 'الصباح',
  'learning.inventoryManager.dailyWorkflow.morning.content': 'تحقق من الإشعارات للحصول على تنبيهات انخفاض المخزون. خطط للمشتريات اليومية.',
  'learning.inventoryManager.dailyWorkflow.during.title': 'أثناء الوردية',
  'learning.inventoryManager.dailyWorkflow.during.content': 'استلم التوصيلات وقم بتحديث كميات المخزون في النظام.',
  'learning.inventoryManager.features.title': 'الميزات',
  'learning.inventoryManager.features.templates.title': 'قوالب التحضير',
  'learning.inventoryManager.features.templates.content': 'الميزة الأهم. اربط المواد بأطباق المنيو بحيث يُخصم المخزون تلقائيًا عند البيع.',
  'learning.inventoryManager.features.notifications.title': 'الإشعارات',
  'learning.inventoryManager.features.notifications.content': 'تنبيهات لانخفاض المخزون وشوائب المخزون السلبي.',
  'learning.deliveryCashier.gettingStarted.title': 'البدء',
  'learning.deliveryCashier.gettingStarted.purpose.title': 'دورك',
  'learning.deliveryCashier.gettingStarted.purpose.content': 'أنت تدير الطلبات الواردة من تطبيقات الطرف الثالث (طلبات، توترز، إلخ) وتضمن معالجتها بشكل صحيح.',
  'learning.deliveryCashier.dailyWorkflow.title': 'سير العمل اليومي',
  'learning.deliveryCashier.features.title': 'الميزات',
  'learning.deliveryCashier.features.pos.title': 'نقطة البيع',
  'learning.deliveryCashier.features.pos.content': 'تُستخدم لإدخال الطلبات. حدد علامة تبويب شركة التوصيل الصحيحة.',
  'learning.deliveryCashier.features.deliveryOrders.title': 'طلبات التوصيل',
  'learning.deliveryCashier.features.deliveryOrders.content': 'إدارة إرسال الطلبات للسائقين.',
  'learning.owner.gettingStarted.title': 'البدء',
  'learning.owner.gettingStarted.purpose.title': 'دورك',
  'learning.owner.gettingStarted.purpose.content': 'بصفتك المالك، لديك سيطرة كاملة على النظام. يمكنك تكوين الإعدادات، وإدارة الموظفين، وتحليل الأداء المالي.',
  'learning.owner.gettingStarted.firstSetup.title': 'الإعداد لأول مرة',
  'learning.owner.gettingStarted.firstSetup.step1': '1. تكوين الإعدادات (الشعار، طابعة الإيصالات، مناطق التوصيل).',
  'learning.owner.gettingStarted.firstSetup.step2': '2. أضف الفئات والأطباق إلى المنيو الخاص بك.',
  'learning.owner.gettingStarted.firstSetup.step3': '3. قم بإنشاء حسابات الموظفين وتعيين الأدوار.',
  'learning.owner.gettingStarted.firstSetup.step4': '4. أضف المواد الخام في المخزون.',
  'learning.owner.gettingStarted.firstSetup.step5': '5. اربط المواد بالأطباق باستخدام قوالب التحضير.',
  'learning.owner.dashboard.title': 'نظرة عامة على لوحة التحكم',
  'learning.owner.dashboard.overview.title': 'المقاييس الرئيسية',
  'learning.owner.dashboard.overview.content': 'تمنحك لوحة التحكم لقطة في الوقت الفعلي لمبيعات اليوم، والطلبات النشطة، وتنبيهات انخفاض المخزون.',
  'learning.owner.dashboard.stats.title': 'الرسوم البيانية',
  'learning.owner.dashboard.stats.content': 'تساعدك الرسوم البيانية المرئية في تحديد ساعات الذروة والعناصر الأكثر مبيعاً.',
  'sidebar.learning': 'مركز التعليم'
};

export default ar;
